import { Breadcrumb, LogoMarquee } from '@/components'
import BottomBanner from './components/BottomBanner'
import DeliveryServices from './components/DeliveryServices'
import HeroBanner from './components/HeroBanner'
import ServiceContent from './components/ServiceContent'
import ServiceFeatures from './components/ServiceFeatures'

const SagawaExp = () => (
  <div className="min-w-[1200px] bg-[#FAFAFA]">
    <HeroBanner />
    <Breadcrumb currentKey="sagawa.breadcrumb.current" />
    <DeliveryServices />
    <div className='pt-[76px] pb-[24px]'>
      <LogoMarquee />
    </div>
    <ServiceContent />
    <ServiceFeatures />
    <BottomBanner />
  </div>
)

export default SagawaExp
